import { Link } from 'react-router-dom';

export default function Footer() {

  const communityLinks = [
    { label: 'Coral Gables', path: '/coral-gables' },
    { label: 'Coconut Grove', path: '/coconut-grove' },
    { label: 'Miami Beach', path: '/miami-beach' },
    { label: 'Pinecrest', path: '/pinecrest' },
    { label: 'Key Biscayne', path: '/key-biscayne' },
    { label: 'South Miami', path: '/south-miami' },
    { label: 'Brickell', path: '/brickell' },
  ];

  const buyerSellerLinks = [
    { label: "Buyers Guide", path: '/buyers-guide' },
    { label: "Sellers Guide", path: '/seller-guide' },
    { label: 'Home Search', path: '/home-search' },
    { label: 'Home Valuation', path: '/home-valuation' },
    { label: 'Market Reports', path: '/market-reports' },
    { label: 'South Florida Relocation', path: '/south-florida-relocation' },
  ];

  const socialLinks = [
    {
      name: 'Instagram',
      icon: 'ri-instagram-line',
      url: 'https://www.instagram.com/julianacostarealtor/',
    },
    {
      name: 'LinkedIn',
      icon: 'ri-linkedin-line',
      url: 'https://www.linkedin.com/in/julianacostamia',
    },
    {
      name: 'Facebook',
      icon: 'ri-facebook-line',
      url: 'https://www.facebook.com/julianmiamirealtor',
    },
    {
      name: 'YouTube',
      icon: 'ri-youtube-line',
      url: '#',
      muted: true,
    },
  ];

  const colLabel = {
    fontFamily: 'Montserrat, sans-serif',
    fontWeight: 600,
    fontSize: '11px',
    letterSpacing: '0.22em',
    textTransform: 'uppercase' as const,
    color: 'rgba(255,255,255,0.55)',
    marginBottom: '24px',
    display: 'block',
  };

  const linkStyle: React.CSSProperties = {
    fontFamily: 'Montserrat, sans-serif',
    fontWeight: 300,
    fontSize: '15px',
    letterSpacing: '0.05em',
    lineHeight: '1.5',
    color: '#ffffff',
    textDecoration: 'none',
    display: 'block',
    transition: 'color 0.3s',
    cursor: 'pointer',
  };

  const hoverOn = (e: React.MouseEvent) => {
    (e.currentTarget as HTMLElement).style.color = '#eebc02';
  };
  const hoverOff = (e: React.MouseEvent) => {
    (e.currentTarget as HTMLElement).style.color = '#ffffff';
  };

  return (
    <footer
      className="text-white pt-20 pb-0"
      style={{ backgroundColor: '#0d0d0d' }}
    >
      <div className="container mx-auto px-6 max-w-7xl">

        {/* 4-Column Grid */}
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-14 pb-16" style={{ borderBottom: '1px solid rgba(255,255,255,0.08)' }}>

          {/* ── COL 1: COMMUNITIES ── */}
          <div>
            <span style={colLabel}>Communities</span>
            <ul className="space-y-4">
              {communityLinks.map((item) => (
                <li key={item.path}>
                  <Link
                    to={item.path}
                    style={linkStyle}
                    onMouseEnter={hoverOn}
                    onMouseLeave={hoverOff}
                  >
                    {item.label}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          {/* ── COL 2: BUYERS & SELLERS ── */}
          <div>
            <span style={colLabel}>Buyers &amp; Sellers</span>
            <ul className="space-y-4">
              {buyerSellerLinks.map((item) => (
                <li key={item.path}>
                  <Link
                    to={item.path}
                    style={linkStyle}
                    onMouseEnter={hoverOn}
                    onMouseLeave={hoverOff}
                  >
                    {item.label}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          {/* ── COL 3: CONTACT ── */}
          <div>
            <span style={colLabel}>Contact</span>
            <ul className="space-y-5 mb-10">
              <li>
                <a
                  href="tel:+17864732565"
                  style={{ ...linkStyle, display: 'flex', alignItems: 'center', gap: '10px' }}
                  onMouseEnter={hoverOn}
                  onMouseLeave={hoverOff}
                >
                  <i className="ri-phone-line flex-shrink-0" style={{ color: 'rgba(238,188,2,0.7)', fontSize: '16px' }}></i>
                  +1 (786) 473-2565
                </a>
              </li>
              <li>
                <a
                  href="mailto:julian.acosta@compass.com"
                  style={{ ...linkStyle, display: 'flex', alignItems: 'center', gap: '10px' }}
                  onMouseEnter={hoverOn}
                  onMouseLeave={hoverOff}
                >
                  <i className="ri-mail-line flex-shrink-0" style={{ color: 'rgba(238,188,2,0.7)', fontSize: '16px' }}></i>
                  julian.acosta@compass.com
                </a>
              </li>
              <li
                style={{ ...linkStyle, display: 'flex', alignItems: 'flex-start', gap: '10px', cursor: 'default', color: 'rgba(255,255,255,0.82)' }}
              >
                <i className="ri-map-pin-line flex-shrink-0 mt-0.5" style={{ color: 'rgba(238,188,2,0.7)', fontSize: '16px' }}></i>
                <span>1515 Sunset Dr Suite 40<br />Coral Gables, FL 33143</span>
              </li>
            </ul>
            <Link
              to="/schedule-consultation"
              className="inline-block font-montserrat text-white text-[13px] uppercase tracking-widest px-6 py-3 transition-all duration-300 cursor-pointer whitespace-nowrap"
              style={{ border: '1px solid rgba(255,255,255,0.25)', fontWeight: 500 }}
              onMouseEnter={e => {
                (e.currentTarget as HTMLElement).style.borderColor = '#eebc02';
                (e.currentTarget as HTMLElement).style.color = '#eebc02';
              }}
              onMouseLeave={e => {
                (e.currentTarget as HTMLElement).style.borderColor = 'rgba(255,255,255,0.25)';
                (e.currentTarget as HTMLElement).style.color = '#ffffff';
              }}
            >
              Schedule Consultation
            </Link>
          </div>

          {/* ── COL 4: CONNECT ── */}
          <div>
            <span style={colLabel}>Connect</span>
            <div className="flex flex-wrap gap-4">
              {socialLinks.map((social, index) => (
                <a
                  key={index}
                  href={social.url}
                  target="_blank"
                  rel="noopener noreferrer"
                  className="w-11 h-11 flex items-center justify-center transition-all duration-300 cursor-pointer"
                  style={{
                    border: '1px solid rgba(255,255,255,0.2)',
                    color: social.muted ? 'rgba(255,255,255,0.25)' : '#ffffff',
                  }}
                  onMouseEnter={e => {
                    if (!social.muted) {
                      (e.currentTarget as HTMLElement).style.borderColor = '#eebc02';
                      (e.currentTarget as HTMLElement).style.color = '#eebc02';
                    }
                  }}
                  onMouseLeave={e => {
                    (e.currentTarget as HTMLElement).style.borderColor = 'rgba(255,255,255,0.2)';
                    (e.currentTarget as HTMLElement).style.color = social.muted ? 'rgba(255,255,255,0.25)' : '#ffffff';
                  }}
                  aria-label={social.name}
                >
                  <i className={`${social.icon} text-xl`}></i>
                </a>
              ))}
            </div>
            {/* Logo */}
            <div className="mt-10">
              <img
                src="https://static.readdy.ai/image/8c6cdb48642edc833d50c52463daca7b/206ae5d05434646e4e52ed54a6c6d1a1.png"
                alt="Julian Acosta | Compass"
                className="h-12 brightness-0 invert opacity-60"
              />
            </div>
          </div>
        </div>

        {/* ── BOTTOM BAR ── */}
        <div className="py-6 flex flex-col md:flex-row items-center justify-between gap-4 text-center md:text-left">

          {/* Left */}
          <p
            style={{
              fontFamily: 'Montserrat, sans-serif',
              fontWeight: 300,
              fontSize: '12px',
              letterSpacing: '0.06em',
              color: 'rgba(255,255,255,0.60)',
            }}
          >
            © 2026 Julian Acosta. All rights reserved.
            <span style={{ margin: '0 6px', color: 'rgba(255,255,255,0.25)' }}>|</span>
            Licensed Real Estate Advisor
            <span style={{ margin: '0 6px', color: 'rgba(255,255,255,0.25)' }}>|</span>
            Compass
          </p>

          {/* Center — Realtor + Equal Housing */}
          <div className="flex items-center gap-4">
            <span
              style={{
                fontFamily: 'Montserrat, sans-serif',
                fontWeight: 600,
                fontSize: '11px',
                letterSpacing: '0.1em',
                color: 'rgba(255,255,255,0.55)',
              }}
            >
              REALTOR®
            </span>
            <span
              style={{
                fontFamily: 'Montserrat, sans-serif',
                fontWeight: 300,
                fontSize: '11px',
                letterSpacing: '0.1em',
                color: 'rgba(255,255,255,0.55)',
              }}
            >
              Equal Housing Opportunity
            </span>
          </div>

          {/* Right */}
          <div className="flex items-center gap-4">
            <Link
              to="/privacy-policy"
              style={{
                fontFamily: 'Montserrat, sans-serif',
                fontWeight: 300,
                fontSize: '12px',
                letterSpacing: '0.06em',
                color: 'rgba(255,255,255,0.60)',
                textDecoration: 'none',
                transition: 'color 0.3s',
                cursor: 'pointer',
              }}
              onMouseEnter={e => { (e.currentTarget as HTMLElement).style.color = '#eebc02'; }}
              onMouseLeave={e => { (e.currentTarget as HTMLElement).style.color = 'rgba(255,255,255,0.60)'; }}
            >
              Privacy Policy
            </Link>
            <span style={{ color: 'rgba(255,255,255,0.25)', fontSize: '12px' }}>|</span>
            <Link
              to="/terms-of-service"
              style={{
                fontFamily: 'Montserrat, sans-serif',
                fontWeight: 300,
                fontSize: '12px',
                letterSpacing: '0.06em',
                color: 'rgba(255,255,255,0.60)',
                textDecoration: 'none',
                transition: 'color 0.3s',
                cursor: 'pointer',
              }}
              onMouseEnter={e => { (e.currentTarget as HTMLElement).style.color = '#eebc02'; }}
              onMouseLeave={e => { (e.currentTarget as HTMLElement).style.color = 'rgba(255,255,255,0.60)'; }}
            >
              Terms of Service
            </Link>
          </div>
        </div>

      </div>
    </footer>
  );
}
